import React, { Component } from 'react';
import {  Toast } from 'antd-mobile';
import * as services from '../projects/services';
import { CommonlyHead } from '../common/headnav';
import './style.less';
export default class PackageItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            opId: this.props.match.params.opId,
            name: this.props.match.params.name,
            price:this.props.match.params.price,
            dataItem: [],
            totalprice:0,
        }
    }
    componentDidMount() {
        services.GetMMPackitem(this.state.opId, '').then(data => {
            if (data.status === 0) {
                 let totalprice=0;
                data.result.forEach((item, index) => {
                    totalprice+=parseFloat(item.price);
                })
                this.setState({ dataItem: data.result,totalprice:totalprice });
            } else {
                Toast.offline(data.message,1);
            }
        });
    }
    render() {
        const { dataItem } = this.state;
        return <div className="packageItem" style={{ minHeight: document.documentElement.clientHeight }}>
            <CommonlyHead barname={this.state.name} />
            {
                !!dataItem ?
                    <div>
                        <div className="xmtitle">体检项目（<span className="y">{this.state.dataItem.length}个</span>）</div>
                        <table className="packtable">
                            <tbody>
                                <tr>
                                    <th >项目名称</th>
                                    <th>项目描述</th>
                                    <th>价格</th>
                                </tr>
                                {
                                    dataItem.map((data, index) => (
                                        <tr key={index}>
                                            <td>{data.name}</td>
                                            <td>{data.description}</td>
                                            <td>￥{data.price}</td>
                                        </tr>
                                    ))
                                }
                                {
                                    <tr><td colSpan="3" className="trright">合计：{this.state.totalprice},实付：{this.state.price}</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    : ''}
        </div>

    }
}